import { useTheme } from '@mui/material/styles';

export interface BrandColors {
  primary: string;
  secondary: string;
}

/** Raw brand colors for data handed to non-MUI renderers, e.g. an embedded widget's default palette. */
export const useBrandColors = (): BrandColors => {
  const { palette } = useTheme();
  return { primary: palette.primary.main, secondary: palette.secondary.main };
};
